/**
 * Constants for the actions feature
 * These are extracted to avoid circular dependencies and duplication
 */

/**
 * Possible states for an action
 */
export enum ActionState {
  SUGGESTED = 'suggested',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
}

/**
 * Action types
 */
export enum ActionType {
  SCHEDULE_APPOINTMENT = 'schedule_appointment',
  GENERATE_CLAIM = 'billing_codes',
  PEP_C = 'pep_c',
  TEMPLATE_CLEANUP = 'template_cleanup',
  LAB_ORDER_SUGGESTION = 'lab_order_suggestion',
  PATIENT_UPDATE = 'patient_update',
  // Add other action types as needed
}
